import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ExternalLink, Play, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, adminHeaders, errorText } from "@/lib/api";

export const Gallery = ({ onUnauthorized }) => {
  const [items, setItems] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/creations", { headers: adminHeaders() });
      setItems(data.items);
    } catch (e) {
      if (e?.response?.status === 401) onUnauthorized();
      else toast.error(errorText(e));
    }
  }, [onUnauthorized]);

  useEffect(() => {
    load();
  }, [load]);

  const remove = async (id) => {
    if (!window.confirm("Bu karikatür galeriden kaldırılsın mı?")) return;
    try {
      await api.delete(`/creations/${id}`, { headers: adminHeaders() });
      setItems((xs) => xs.filter((x) => x.id !== id));
    } catch (e) {
      toast.error(errorText(e));
    }
  };

  return (
    <section data-testid="admin-gallery">
      <div className="flex items-center justify-between">
        <div>
          <p className="eyebrow">Galeri</p>
          <h2 className="font-display mt-1 text-xl font-extrabold">{items ? `${items.length} karikatür` : "Yükleniyor…"}</h2>
        </div>
        <Link to="/admin/slideshow" className="btn btn-accent" data-testid="open-slideshow-button">
          <Play size={16} /> Slayt
        </Link>
      </div>
      {items && items.length === 0 && <p className="glass mt-6 p-8 text-center text-slate-400" data-testid="gallery-empty">Henüz karikatür yok.</p>}
      <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {items?.map((c) => (
          <figure key={c.id} className="glass group relative overflow-hidden p-1.5" data-testid={`gallery-item-${c.id}`}>
            <img src={c.frame_url} alt="" loading="lazy" className="aspect-[3/4] w-full rounded-xl object-cover" />
            <figcaption className="flex items-center justify-between px-1 pt-2 text-[10px] text-slate-400">
              <span className="truncate">
                {c.label && <span className="mr-1 font-semibold text-slate-200" data-testid={`gallery-label-${c.id}`}>{c.label} ·</span>}
                {new Date(c.created_at).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })}
              </span>
              <span className="flex gap-1">
                <a href={c.share_url} target="_blank" rel="noreferrer" className="btn btn-ghost !p-1.5" aria-label="Paylaşım sayfası" data-testid={`gallery-open-${c.id}`}>
                  <ExternalLink size={12} />
                </a>
                <button onClick={() => remove(c.id)} className="btn btn-ghost !p-1.5 hover:!border-red-400" aria-label="Sil" data-testid={`gallery-delete-${c.id}`}>
                  <Trash2 size={12} />
                </button>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};
